"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analysis = exports.questions = void 0;

var _screeners = require("../../screeners");

var _utils = require("../../screeners/utils");

var surveyscreeners = [_utils.screeners.WHO5, _utils.screeners.ALLIANZ_STRESS, _utils.screeners.PERSONALISATION];
var causalAnalysisQuestionScale = ["Relationship issue (friend, family or partner)", "Financial stress", "Health issue (self or other)", "Work stress", "Study stress", "Job loss", "Personal mental health issue", "Lack of support or resources", "Traumatic or stressful life event", "Loneliness/isolation", "Caring for another", "Parenting", "Recent or upcoming major change or major decision", "Grief or loss", "Bullying", "Struggling with identity", "Pressure to perform", "Other"];
var questions = (0, _screeners.expandscreeners)([_utils.screeners.ALLIANZ_WHO5, {
  extraText: "Over the past month,",
  batteryId: "WHO5",
  type: "multiSkip",
  meta: {
    answerLabel: "My challenges are...",
    skipLabel: "I have no challenges at work",
    responsePrefix: "My challenges are: ",
    noResponsePrefix: "I have no challenges at work"
  },
  prompt: "have any of the following <b>made it hard for you to function<br /> effectively?</b> (you can choose multiple options)",
  options: causalAnalysisQuestionScale
}, _utils.screeners.ALLIANZ_STRESS]);
exports.questions = questions;

var analysis = function analysis(answers, bonus) {
  if (!answers) return null;
  var results = {};
  surveyscreeners.forEach(function (screener) {
    var filteredQuestions = questions.filter(function (question) {
      return question.batteryId === screener;
    });
    var answer;
    if (screener === "ALLIANZ_STRESS") answer = answers["STRESS"] || answers["ALLIANZ_STRESS"];else answer = answers[screener];
    results[screener] = (0, _screeners.extractResults)(filteredQuestions, answer, screener); // answer: {WHO5: Array, STRESS: Array}

    filteredQuestions.forEach(function (q, i) {
      if (!q.key) return;
      results[q.key] = q.eval(answer[i]);
    });
  });
  return results;
};

exports.analysis = analysis;